"use strict";

angular.module('app.models.menuEntry', []).//

factory('__MenuEntry', ['restmod', 'appConfig', '__Datapoint', 'f_User', '$filter', function (restmod, appConfig, __Datapoint, f_User, $filter) {


    return restmod.model('/Favorite').mix('BaseModel').mix({

        prepareMenuEntry: function () {
            if (this.UserLevelWrite <= f_User.getUserLevel()) {
                this.$UI.canWrite = true;
            }
        },
        updateMenuEntryData: function (data) {


            this.ImageName = data.ImageName;
            this.Sort = data.Sort;
            this.UserLevelRead = data.UserLevelRead;
            this.UserLevelWrite = data.UserLevelWrite;
            this.ShortText = data.ShortText;
            this.ParentMenuEntryId = data.ParentMenuEntryId;
            this.MenuEntryType = data.MenuEntryType;
            this.VisualizationDatapoints = data.VisualizationDatapoints;
            this.DisplayName = data.DisplayName;
            this.$UI.buildAllDatapoints = false;
            this.$dispatch('build-datapoints');


        },
        $pk: 'MenuEntryId',
        _type: {map: '$type'},
        VisualizationDatapoints: {'hasMany': '__Datapoint'},
        $config: {name: 'ResponseData', plural: 'ResponseData'},
        $hooks: {
            'build-datapoints': function () {

                var self = this;
                if (!self.VisualizationDatapoints || self.$UI.buildAllDatapoints == true) {
                    return
                }
                ;

               // delete self.$UI.LeftSideVisualizationDatapoint;
               // delete self.$UI.RightSideVisualizationDatapoint;
                this.$UI.windowOpen = [];
                this.$UI.activeActor = [];
                this.$UI.actualTemp = [];
                for (var i = 0; i < self.VisualizationDatapoints.length; ++i) {

                    var dataPoint = self.VisualizationDatapoints[i];
                    self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]).$dispatch('build');

                    self.VisualizationDatapoints[i].$UI.restMod = true;

                    var searchDP = [
                        "9c9aef3d-3862-4e68-b687-c88b9b975958", // windowOpen
                        "7ac71d63-d850-41a7-af40-ee9ac442f120", // activeActor
                        "777c1a8e-ec1c-4a15-9bcc-4ec5b8e0e4f4" // temperature
                    ];

                    // build first two dataPoints

                    // build battery and signal status
                    //for (var i = 0; i < self.VisualizationDatapoints.length; ++i) {

                    /*if (!dataPoint.Config) {
                        continue;
                    };*/

                    var index = searchDP.indexOf(dataPoint.DatapointConfig.DatapointConfigId);

                    switch (index) {
                        case 0 :
                            this.$UI.windowOpen.push(self.VisualizationDatapoints[i].$dispatch('set-color-class'));
                            break;
                        case 1:

                            this.$UI.activeActor.push(self.VisualizationDatapoints[i].$dispatch('set-color-class'));
                            break;
                        case 2:
                            this.$UI.actualTemp.push(self.VisualizationDatapoints[i].$dispatch('set-color-class'));
                            break;
                        default:

                    }
                    ;
                    // }
                    // build first two dataPoints


                    if (!self.$UI.LeftSideVisualizationDatapoint) {
                        self.$UI.LeftSideVisualizationDatapoint = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]);
                        self.$UI.LeftSideVisualizationDatapoint.$UI.restMod = true;
                    } else if (!self.$UI.RightSideVisualizationDatapoint) {
                        self.$UI.RightSideVisualizationDatapoint = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]);
                        self.$UI.RightSideVisualizationDatapoint.$UI.restMod = true;
                    } else {
                        self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]);
                    }


                    if (self.$UI.RightSideVisualizationDatapoint) self.$UI.RightSideVisualizationDatapoint.$dispatch('build').$dispatch('set-color-class');
                    if (self.$UI.LeftSideVisualizationDatapoint) self.$UI.LeftSideVisualizationDatapoint.$dispatch('build').$dispatch('set-color-class');


                }
                if (this.$UI.actualTemp.length > 0) {
                    //console.log(this.$UI.actualTemp);
                }
                self.$UI.buildAllDatapoints = true;
            },
            'after-request': function (_req) {
                if (typeof _req.data == 'string') {
                    _req.data = {'MenuEntryId': _req.data};
                }
            },
            'after-feed': function () {

                this.$UI = !this.$UI ? {} : this.$UI;
                if(this.ImageName && this.ImageName.indexOf('_') >= 0){
                    var a = this.ImageName.split('_');
                    this.ImageName = a[0];
                }
                this.$dispatch('build-datapoints');
                this.prepareMenuEntry();
            },
            'before-save': function (_req) {
                /* Transform $save Calls */
                _req.url = appConfig().api_host + 'Menu/AddOrUpdateCustomMenuEntry';
                _req.method = 'POST';
                var o = {$type: _req.data._type};
                var u = _req.data;
                delete u._type;
                var DeviceId = (o.DeviceId) ? o.DeviceId : '00000000-0000-0000-0000-000000000000';
                _req.data = {'DeviceId': DeviceId, 'MenuEntry': angular.extend(o, u)};

            },
            'before-destroy': function (_req) {
                _req.data = {'DeviceId': this.DeviceId, 'EntryId': this.MenuEntryId};
                _req.url = appConfig().api_host + 'Menu/RemoveCustomMenuEntry';
                _req.method = 'POST';
            }
        },
        $extend: {
            Scope: {

                $byId: function (menuEntryId, deviceId, withDetails) {
                    return this.$collection(false).$decorate({
                        'before-request': function (_req) {
                            if (menuEntryId && deviceId) {
                                _req.method = 'POST';
                                _req.data = {
                                    MenuEntryIds: [menuEntryId],
                                    DeviceId: deviceId,
                                    WithDetails: withDetails
                                };

                                _req.params = null;
                                _req.url = appConfig().api_host + 'Menu/GetMenuEntriesByIds';
                                _req.isArray = true;
                            }
                        },
                        'after-request': function (_req) {
                            //TODO: this is not working, check
                            _req.data = _req.data.length == 1 ? _req.data[0] : {};
                        }
                    }, function () {
                        return this.$find();
                    });

                },
                $getRooms: function (params) {
                    return this.$collection(params).$decorate(
                        {
                            'before-request': function (_req) {
                                _req.method = 'POST';
                                _req.params = null;
                                _req.data = params;
                                _req.url = appConfig().api_host + 'Menu/GetCustomMenuEntries';
                            }
                        }, function () {
                            return this.$fetch();
                        });
                }
            },
            List: {
                $filter: function (_what) {
                    var ordered = $filter('filter')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                },
                $orderBy: function (_what) {
                    var ordered = $filter('orderBy')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                },
                getById: function (id) {
                    for (var i = 0; i < this.length; ++i) {
                        if (this[i].MenuEntryId === id) {
                            return this[i];
                        }
                    }
                }
            }

        }
    })
}]);
